import { FETCH_DRINKS, FETCH_DRINK, SET_DRINKS_FILTER } from "./types";
import hdmapi from "../apis/hdmapi";

export const fetchDrinks = () => async dispatch => {
  const response = await hdmapi.get("/drinks");
  dispatch({ type: FETCH_DRINKS, payload: response.data.drinks });
};

export const setDrinksFilter = filter => {
  return {
    type: SET_DRINKS_FILTER,
    filter
  };
};

export const fetchDrink = id => async dispatch => {
  const response = await hdmapi.get(`/drinks/${id}`);
  dispatch({ type: FETCH_DRINK, payload: response.data });
};
